/**
 * Component - activityCalendar
 */

export const activityCalendar = (): void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-activityCalendar') as unknown as HTMLElement[]
  componentSelector.forEach((component: HTMLElement) => {
    console.log(component)
  })
}
